import { render } from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=template&id=2b419b6e&scoped=true&ts=true"
import script from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=script&lang=ts"
export * from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=script&lang=ts"

import "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=style&index=0&id=2b419b6e&scoped=true&lang=css"
import "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=style&index=1&id=2b419b6e&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b419b6e"]])

export default __exports__